import { FC, useState } from 'react'
import { ChevronDownIcon } from 'lucide-react'
import { ModuleType } from '../../../../types'
import { formatMultipleString } from '../../../../utils'
import { CoursePreviewContentLesson } from '..'
import { StyledCoursePreviewContentModule } from '.'

type Props = {
  module: ModuleType
  index: number
}

const CoursePreviewContentModule: FC<Props> = ({ module, index }) => {
  const [expanded, setExpanded] = useState(index === 0)

  return (
    <StyledCoursePreviewContentModule $expanded={expanded}>
      <button className="module-btn" onClick={() => setExpanded(!expanded)}>
        <div className="module-title-container">
          <ChevronDownIcon style={{ transform: `rotate(${expanded ? 180 : 0}deg)` }} />
          <span className="module-title">{module.title}</span>
        </div>
        <span className="module-lesson-count">
          {formatMultipleString('lesson', module.lessons?.length)}
        </span>
      </button>
      {expanded && (
        <div className="module-lesson-list">
          {module.lessons?.map((lesson, index) => {
            return <CoursePreviewContentLesson lesson={lesson} index={index} key={lesson._id} />
          })}
        </div>
      )}
    </StyledCoursePreviewContentModule>
  )
}

export default CoursePreviewContentModule
